import { render, staticRenderFns } from "./Kollel.vue?vue&type=template&id=7a067a69&"
import script from "./Kollel.vue?vue&type=script&lang=js&"
export * from "./Kollel.vue?vue&type=script&lang=js&"
import style0 from "./Kollel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports